import React, { useEffect, useId, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPaymentCards, getPaymentCardStatus } from '../api';
export default function PaymentChoice({ value, onChange, disabled = false }) {
  const [data, setData] = useState(null);
  const name = useId();
  useEffect(() => {
    let active = true;
    let loading = false;
    const refresh = async () => {
      if (loading) return;
      loading = true;
      try {
        const { data: current } = await getPaymentCards();
        if (!active) return;
        setData(current);
        const pending = current.enabled ? current.cards.filter(card => ['WAITING', 'UNKNOWN'].includes(card.status)) : [];
        if (!pending.length) return;
        const updated = await Promise.allSettled(pending.map(card => getPaymentCardStatus(card.id)));
        const confirmed = new Map(updated.filter(result => result.status === 'fulfilled').map(result => [result.value.data.id, result.value.data]));
        if (active) setData({ ...current, cards: current.cards.map(card => confirmed.get(card.id) || card) });
      } catch { /* The bank form is available when the saved card list cannot be loaded. */ }
      finally { loading = false; }
    };
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      active = false;
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);
  const cards = data?.chargeEnabled ? data.cards.filter(card => card.usable) : [];
  const hasSelectedCard = cards.some(card => card.id === value);
  useEffect(() => {
    if (data && value && !hasSelectedCard) onChange('');
  }, [data, value, hasSelectedCard, onChange]);
  return <fieldset className="checkout-card pickup-points-list" disabled={disabled}>
    <legend>Способ оплаты</legend>
    {cards.map(card => <label key={card.id} className="pickup-point-card"><input type="radio" name={name} checked={value === card.id} onChange={() => onChange(card.id)} /><span><strong>Сохранённая карта •••• {card.lastFour}</strong><small>Списание после нажатия кнопки оплаты.</small></span></label>)}
    <label className="pickup-point-card"><input type="radio" name={name} checked={!hasSelectedCard} onChange={() => onChange('')} /><span><strong>Оплатить через форму Т-Банка</strong><small>Введите реквизиты карты или выберите другой способ на странице банка.</small></span></label>
    {data?.enabled && !disabled && <div>
      <Link to="/profile#payment-methods-title" target="_blank" rel="noopener noreferrer">{cards.length ? 'Привязать ещё карту' : 'Привязать карту'}</Link>
      <p>Профиль откроется в новой вкладке. После привязки вернитесь к оплате.</p>
    </div>}
  </fieldset>;
}
